module.exports = __webpack_public_path__ + "img/1498918019.f6f13114.jpg";